import React, { useEffect, useState } from 'react';
import { Button } from '../../../../components/ui/button';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../../../components/ui/alert-dialog';
import { useUploadHistoryContext } from '../../../../contexts/UploadHistoryContext';
import TanstackColumnsToggle from '../../../../components/TanstackColumnsToggle';
import SelectInput from '../../../../components/SelectInput';
import { useDispatch, useSelector } from 'react-redux';
import { loadPageData } from '../../../../store/uploads/actions';
import { DatePicker } from '../../../../components/DatePicker';


const FiltersModal = ({openFilterModal, closeModal, clearFilters, applyFilters, handleFilterChange}) => {
    const { table } = useUploadHistoryContext();
    const dispatch = useDispatch();

    const { filters, pageLoadData } = useSelector((state) => state.Uploads);

    useEffect(() => {
        dispatch(loadPageData());
    }, [dispatch]);

    const initialVisibility = table.getAllColumns().reduce((acc, column) => {
        acc[column.id] = column.getIsVisible();
        return acc;
    }, {});

    const [columnVisibility, setColumnVisibility] = useState(initialVisibility);

    return (
        <AlertDialog open={openFilterModal} onDismiss={closeModal}>
            <AlertDialogHeader className="hidden">
                <AlertDialogTitle>Filters</AlertDialogTitle>
            </AlertDialogHeader>
            <AlertDialogContent className="min-w-[55%] max-h-[80vh] overflow-y-auto" description="Upload Log Filters">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 relative">
                    <div className="pr-4 border-b md:border-b-0 pb-4 mb-4 md:pb-0 md:mb-0">
                        <h4 className="mb-4 font-bold">Filters</h4>

                        {pageLoadData?.sourceTypes?.length > 0 && <div className='grid grid-cols-5 mb-2'>
                            <p className="col-span-2">Source Type: </p>
                            <div className="col-span-3">
                                <SelectInput
                                    type="list"
                                    list={pageLoadData?.sourceTypes}
                                    placeholder="Select Source Type"
                                    onChange={(value) => handleFilterChange('sourceType', value)}
                                    selectedValue={filters.sourceType}
                                    clearable={true}
                                />
                            </div>
                        </div>}

                        {pageLoadData?.masterProjects?.length > 0 && <div className='grid grid-cols-5 mb-2'>
                            <p className="col-span-2">Master Project: </p>
                            <div className="col-span-3">
                                <SelectInput
                                    type="map"
                                    list={pageLoadData?.masterProjects}
                                    placeholder="Select Master Project"
                                    onChange={(value) => handleFilterChange('masterProject', value)}
                                    selectedValue={filters.masterProject}
                                    clearable={true}
                                />
                            </div>
                        </div>}

                        {pageLoadData?.projects?.length > 0 && <div className='grid grid-cols-5 mb-2'>
                            <p className="col-span-2">Project: </p>
                            <div className="col-span-3">
                                <SelectInput
                                    type="map"
                                    list={pageLoadData?.projects}
                                    placeholder="Select Project"
                                    onChange={(value) => handleFilterChange('project', value)}
                                    selectedValue={filters.project}
                                    clearable={true}
                                />
                            </div>
                        </div>}

                        {pageLoadData?.vendors?.length > 0 && <div className='grid grid-cols-5 mb-2'>
                            <p className="col-span-2">Vendor: </p>
                            <div className="col-span-3">
                                <SelectInput
                                    type="map"
                                    list={pageLoadData?.vendors}
                                    placeholder="Select Vendor"
                                    onChange={(value) => handleFilterChange('vendor', value)}
                                    selectedValue={filters.vendor}
                                    clearable={true}
                                />
                            </div>
                        </div>}

                        {pageLoadData?.channelPartners?.length > 0 && <div className='grid grid-cols-5 mb-2'>
                            <p className="col-span-2">Channel Partner: </p>
                            <div className="col-span-3">
                                <SelectInput
                                    type="map"
                                    list={pageLoadData?.channelPartners}
                                    placeholder="Select Channel Partner"
                                    onChange={(value) => handleFilterChange('channelPartner', value)}
                                    selectedValue={filters.channelPartner}
                                    clearable={true}
                                />
                            </div>
                        </div>}

                        {pageLoadData?.users?.length > 0 && <div className='grid grid-cols-5 mb-2'>
                            <p className="col-span-2">SPOC: </p>
                            <div className="col-span-3">
                                <SelectInput
                                    type="map"
                                    list={pageLoadData?.users}
                                    placeholder="Select SPOC"
                                    onChange={(value) => handleFilterChange('spoc', value)}
                                    selectedValue={filters.spoc}
                                    clearable={true}
                                />
                            </div>
                        </div>}

                        {pageLoadData?.leadSources?.length > 0 && <div className='grid grid-cols-5 mb-2'>
                            <p className="col-span-2">Lead Source: </p>
                            <div className="col-span-3">
                                <SelectInput
                                    type="map"
                                    list={pageLoadData?.leadSources}
                                    placeholder="Select Lead Source"
                                    onChange={(value) => handleFilterChange('leadSource', value)}
                                    selectedValue={filters.leadSource}
                                    clearable={true}
                                />
                            </div>
                        </div>}

                        {pageLoadData?.dataCategories?.length > 0 && <div className='grid grid-cols-5 mb-2'>
                            <p className="col-span-2">Data Category: </p>
                            <div className="col-span-3">
                                <SelectInput
                                    type="map"
                                    list={pageLoadData?.dataCategories}
                                    placeholder="Select Data Category"
                                    onChange={(value) => handleFilterChange('dataCategory', value)}
                                    selectedValue={filters.dataCategory}
                                    clearable={true}
                                />
                            </div>
                        </div>}

                        <div className='grid grid-cols-5 mb-2'>
                            <p className="col-span-2">Start Date: </p>
                            <div className="col-span-3">
                                {/* <DatePicker
                                    date={filters.startDate}
                                    placeholder="Select Start Date"
                                    setDate={(e) => {
                                        console.log("e", typeof e)
                                        // handleFilterChange(filters.startDate, e.target.value)
                                    }}
                                /> */}
                                <DatePicker
                                    placeholder="Select Start Date"
                                    date={filters.startDate}
                                    disabled={false}
                                    setDate={(e) => handleFilterChange("startDate", e)}
                                    past={true}
                                />
                            </div>
                        </div>

                        <div className='grid grid-cols-5 mb-2'>
                            <p className="col-span-2">End Date: </p>
                            <div className="col-span-3">
                                <DatePicker
                                    placeholder="Select End Date"
                                    date={filters.endDate}
                                    disabled={false}
                                    setDate={(e) => handleFilterChange("endDate", e)}
                                    past={true}
                                />
                            </div>
                        </div>

                    </div>
                    <div className="md:pl-4 pb-4 md:pb-0">
                        <h4 className="mb-4 font-bold">Column Visibility</h4>
                        <TanstackColumnsToggle table={table} columnVisibility={columnVisibility} setColumnVisibility={setColumnVisibility} />
                    </div>
                    {/* Vertical Line */}
                    <div className="absolute inset-y-0 left-1/2 w-px bg-gray-300 hidden md:block"></div>
                </div>
                <AlertDialogFooter>
                <AlertDialogCancel onClick={closeModal}>Cancel</AlertDialogCancel>
                <Button type="button" variant="secondary" onClick={clearFilters}>
                    Clear All
                </Button>
                <Button type="button" onClick={e => applyFilters(columnVisibility)}>
                    Apply
                </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default FiltersModal;
